export const IMPORT_DEPENDENCY_TYPES = {
    default: 'default',
    module: 'module',
};
